import { useEffect, useState } from "react";
import React from "react";
import { Link, useLocation } from "react-router-dom";

import { api, ApiClientError } from "../api";

export function TokenActionPage({
  action,
}: {
  action: "confirm" | "unsubscribe" | "reactivate";
}) {
  const { search } = useLocation();
  const [message, setMessage] = useState("Processing your request…");
  const [status, setStatus] = useState<"processing" | "complete" | "failed">(
    "processing",
  );
  useEffect(() => {
    setStatus("processing");
    setMessage("Processing your request…");
    const token = new URLSearchParams(search).get("token") ?? "";
    const request =
      action === "reactivate"
        ? api("/api/public/account/reactivate", {
            method: "POST",
            body: JSON.stringify({ token }),
          })
        : api(
            action === "confirm"
              ? `/api/public/waitlist/confirm?token=${encodeURIComponent(token)}`
              : `/api/public/unsubscribe?token=${encodeURIComponent(token)}`,
          );
    void request
      .then(() => {
        setStatus("complete");
        setMessage(
          action === "confirm"
            ? "Your subscription is confirmed."
            : action === "unsubscribe"
              ? "You have been unsubscribed."
              : "Your account has been reactivated. You may sign in again.",
        );
      })
      .catch((caught: unknown) => {
        setStatus("failed");
        setMessage(
          caught instanceof ApiClientError
            ? caught.message
            : "The link could not be processed.",
        );
      });
  }, [action, search]);
  return (
    <div className="page-section">
      <div className="container narrow token-result">
        <p className="kicker">Account request</p>
        <h1>
          {status === "processing"
            ? "Processing request"
            : status === "failed"
              ? "Request not completed"
              : "Request completed"}
        </h1>
        <div
          className={status === "failed" ? "alert alert-error" : "alert"}
          role={status === "failed" ? "alert" : "status"}
          aria-live="polite"
        >
          {message}
        </div>
        <Link
          className="button"
          to={action === "reactivate" ? "/sign-in" : "/"}
        >
          {action === "reactivate" ? "Sign in" : "Return home"}
        </Link>
      </div>
    </div>
  );
}
